import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface State {
  params: {
    instanceId?: string
    pipelineId?: string
    nodeId?: string | null
  }
  queryParams: {
    datatype?: 'logs' | 'spans' | 'metrics' | ''
    query?: string
    groupBy?: string
  }
}

interface Actions {
  setParams: (variables: State['params']) => void
  setQueryParams: (variables: State['queryParams']) => void
}

export const useNavigationStateStore = create(
  persist<State & Actions>(
    (set) => ({
      // State
      params: {
        instanceId: '',
        pipelineId: '',
        nodeId: '',
      },
      queryParams: {
        datatype: '',
        query: '',
        groupBy: '',
      },

      // Actions
      setParams: (params: State['params']) =>
        set((state) => ({
          params: {
            ...state.params,
            ...params,
          },
        })),
      setQueryParams: (queryParams: State['queryParams']) =>
        set((state) => ({
          queryParams: {
            ...state.queryParams,
            ...queryParams,
          },
        })),
    }),
    {
      name: 'navigation-state',
    }
  )
)
